<template>
    <div class="py-4 container-fluid">        
        <div class="row">
            <div class="col-lg-6" v-if="['Admin'].includes(userRoleName)">             
                <div class="card mb-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.Reference_types') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/referencetype/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_reference_type')">{{ $t('settings.New_reference_type') }}</router-link>
                        </div>                                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="referenceTypeKey" id="referencetype-list" class="table table-flush">
                                <thead>
                                    <tr>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Name') }}</p></th>                                                                     
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in referencetypes" v-bind:key="item.id">
                                        <td class="text-sm font-weight-normal">
                                            {{ item.name }}<br>                                            
                                        </td>                                        
                                        <td>
                                            <div class="float-end">
                                                <button :data-id="item.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                                </button>
                                                <button :data-id="item.id" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">                
                <div class="card mb-4">
                    <div class="row">                        
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.Studebook_status') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/studebookstatus/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_studebook_status')">{{ $t('settings.New_studebook_status') }}</router-link>
                        </div>                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="studebookstatusKey" id="studebookstatus-list" class="table table-flush">
                                <thead>
                                    <tr>                                        
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Code') }}</p></th>                                        
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in studebookstatuses" v-bind:key="item.id">                                        
                                        <td class="text-sm font-weight-normal">
                                            {{ item.code }}
                                            <span v-if="['Admin'].includes(userRoleName)">
                                                <br><small><b>{{ $t('settings.Association') }}</b>: {{ item.abbreviation }}</small>
                                            </span>
                                            <br><small><b>{{ $t('settings.Description') }}</b>: {{ item.description }}</small>
                                        </td>                                        
                                        <td>
                                            <div class="d-flex flex-wrap justify-content-end gap-2">
                                                <button :data-id="item.id" class="btn btn-sm bg-gradient-success edit-button" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">edit</i>
                                                </button>                                                
                                                <button :data-id="item.id" :disabled="!item.canDelete" class="btn btn-sm bg-gradient-danger delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">delete</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">                
                <div class="card mb-4">
                    <div class="row">                        
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.Studebook_section') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/studebooksection/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_studebook_section')">{{ $t('settings.New_studebook_section') }}</router-link>
                        </div>                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="studebooksectionKey" id="studebooksection-list" class="table table-flush">
                                <thead>
                                    <tr>                                        
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Code') }}</p></th>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Section_code') }}</p></th>                                        
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in studebooksections" v-bind:key="item.id">                                        
                                        <td class="text-sm font-weight-normal">
                                            {{ item.code }}<br>
                                            <small><b>{{ $t('settings.Description') }}</b>: {{ item.description }}</small>
                                            <span v-if="['Admin'].includes(userRoleName)">
                                                <br><small><b>{{ $t('settings.Association') }}</b>: {{ item.abbreviation }}</small>
                                            </span>
                                        </td>
                                        <td class="text-sm font-weight-normal">
                                            {{ item.sectionCode }}<br>
                                            <small>
                                                <b>{{ $t('settings.Section') }}</b>: {{ item.section }}<br>
                                                <b>{{ $t('settings.Classification') }}</b>: {{ item.sectionClassification }}
                                            </small>
                                        </td>                                        
                                        <td>
                                            <div class="d-flex flex-wrap justify-content-end gap-2">
                                                <button :data-id="item.id" class="btn btn-sm bg-gradient-success edit-button" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">edit</i>
                                                </button>
                                                <button :data-id="item.id" :disabled="!item.canDelete" class="btn btn-sm bg-gradient-danger delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">delete</i>
                                                </button>
                                            </div>                                            
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card mb-4">
                    <div class="row">                        
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.Breeds') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/breed/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_breed')">{{ $t('settings.New_breed') }}</router-link>
                        </div>                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="breedKey" id="breed-list" class="table table-flush">
                                <thead>
                                    <tr>                                        
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Code') }}</p></th>                                        
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.RVO_recognized') }}</p></th>
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in breeds" v-bind:key="item.id">                                        
                                        <td class="text-sm font-weight-normal">
                                            {{ item.code }}
                                            <span v-if="['Admin'].includes(userRoleName)">
                                                <br><small><b>{{ $t('settings.Association') }}</b>: {{ item.abbreviation }}</small>
                                            </span>
                                            <br><small><b>{{ $t('settings.Name') }}</b>: {{ item.name }}</small>
                                        </td>                                        
                                        <td class="text-sm font-weight-normal">
                                            <i class="material-symbols-rounded opacity-10 font-size-14" 
                                                :class="item.rvoRecognized ? 'text-success' : 'text-danger'"
                                                aria-hidden="true">
                                                {{ item.rvoRecognized ? 'thumb_up' : 'thumb_down' }}
                                            </i>
                                        </td>
                                        <td>
                                            <div class="d-flex flex-wrap justify-content-end gap-2">
                                                <button :data-id="item.id" class="btn btn-sm bg-gradient-success edit-button" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">edit</i>
                                                </button>
                                                <button :data-id="item.id" :disabled="!item.canDelete" class="btn btn-sm bg-gradient-danger delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">delete</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if="['Admin'].includes(userRoleName)">
                <div class="card mb-4">
                    <div class="row">                        
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.References') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/reference/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_reference')">{{ $t('settings.New_reference') }}</router-link>
                        </div>                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="referenceKey" id="reference-list" class="table table-flush">
                                <thead>
                                    <tr>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Name') }}</p></th>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Reference_type') }}</p></th>
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in references" v-bind:key="item.id">
                                        <td class="text-sm font-weight-normal">
                                            {{ item.name }}<br>                                            
                                        </td>
                                        <td class="text-sm font-weight-normal">
                                            {{ item.referenceTypeName }}                                            
                                        </td>
                                        <td>
                                            <div class="float-end">
                                                <button :data-id="item.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                                </button>
                                                <button :data-id="item.id" :disabled="!item.canDelete" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if="['Admin'].includes(userRoleName)">
                <div class="card mb-4">
                    <div class="row">                        
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.Attributes') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/attribute/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_attribute')">{{ $t('settings.New_attribute') }}</router-link>
                        </div>                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">                            
                            <table :key="attributeKey" id="attribute-list" class="table table-flush">
                                <thead>
                                    <tr>                                        
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Attribute') }}</p></th>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.SortOrder') }}</p></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in attributes" v-bind:key="item.id">
                                        <td class="text-sm font-weight-normal">
                                            {{ item.attributeCode }} 
                                            <small><br >{{ item.groupCode }} [{{ item.group }}]</small>
                                            <small><br >{{ item.attribute1 }}</small>
                                        </td>                                        
                                        <td class="text-sm font-weight-normal">
                                            {{ item.sortorder }}
                                        </td>
                                        <td>
                                            <div class="d-flex flex-wrap justify-content-end gap-2">
                                                <button :data-id="item.id" class="btn btn-sm bg-gradient-success edit-button" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">edit</i>
                                                </button>
                                                <button :data-id="item.id" class="btn btn-sm bg-gradient-danger delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">delete</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if="['Admin'].includes(userRoleName)">
                <div class="card mb-4">
                    <div class="row">                        
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.Mail_templates') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/mailtemplate/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_mail_template')">{{ $t('settings.New_mail_template') }}</router-link>
                        </div>                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="mailtemplateKey" id="mailtemplate-list" class="table table-flush">
                                <thead>
                                    <tr>                                        
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Name') }}</p></th>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Subject') }}</p></th>                                                                                
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in mailtemplates" v-bind:key="item.id">                                        
                                        <td class="text-sm font-weight-normal">
                                            {{ item.name }}<br>                                            
                                        </td>
                                        <td class="text-sm font-weight-normal">
                                            {{ item.subject }}
                                        </td>                                        
                                        <td>
                                            <div class="d-flex flex-wrap justify-content-end gap-2">
                                                <button :data-id="item.id" class="btn btn-sm bg-gradient-success edit-button" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">edit</i>
                                                </button>
                                                <!--
                                                <button :data-id="item.id" class="btn btn-sm bg-gradient-danger delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;">delete</i>
                                                </button>
                                                -->
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if="['Admin'].includes(userRoleName)">             
                <div class="card mb-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.User_manual_types') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/usermanualtype/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_user_manual_type')">{{ $t('settings.New_user_manual_type') }}</router-link>
                        </div>                                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="userManualTypeKey" id="usermanualtype-list" class="table table-flush">
                                <thead>
                                    <tr>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Name') }}</p></th>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.IsGlobal') }}</p></th>
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in usermanualtypes" v-bind:key="item.id">
                                        <td class="text-sm font-weight-normal">
                                            {{ item.name }}
                                        </td>
                                        <td class="text-sm font-weight-normal">
                                            <i class="material-symbols-rounded opacity-10 font-size-14" 
                                                :class="item.isGlobal ? 'text-success' : 'text-danger'"
                                                aria-hidden="true">
                                                {{ item.isGlobal ? 'thumb_up' : 'thumb_down' }}
                                            </i>
                                        </td>
                                        <td>
                                            <div class="float-end">
                                                <button :data-id="item.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                                </button>
                                                <button :data-id="item.id" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if="['Admin'].includes(userRoleName)">             
                <div class="card mb-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.User_manuals') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/usermanual/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_user_manual_type')">{{ $t('settings.New_user_manual') }}</router-link>
                        </div>                                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="userManualKey" id="usermanual-list" class="table table-flush">
                                <thead>
                                    <tr>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Title') }}</p></th>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Active') }}</p></th>
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in usermanuals" v-bind:key="item.id">
                                        <td class="text-sm font-weight-normal">
                                            {{ item.title }}
                                            <span v-if="item.associationId !== ''">
                                                <br><small><b>{{ $t('settings.Association') }}</b>: {{ item.associationName }}</small>
                                            </span> 
                                            <span v-if="item.roleName !== ''">
                                                <br><small><b>{{ $t('settings.Role') }}</b>: {{ item.roleName }}</small>
                                            </span>     
                                        </td>
                                        <td class="text-sm font-weight-normal">
                                            <i class="material-symbols-rounded opacity-10 font-size-14" 
                                                :class="item.isActive ? 'text-success' : 'text-danger'"
                                                aria-hidden="true">
                                                {{ item.isActive ? 'thumb_up' : 'thumb_down' }}
                                            </i>
                                        </td>
                                        <td>
                                            <div class="float-end">
                                                <button :data-id="item.manualId" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                                </button>
                                                <button :data-id="item.manualId" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card mb-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <h6 class="ms-3 mt-3 mb-2">
                                {{ $t('settings.Notifications') }}
                            </h6>
                        </div>
                        <div class="col-lg-6 d-flex flex-column justify-content-center">
                            <router-link to="/notification/create" class="mt-2 me-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto" :title="$t('settings.New_notification')">{{ $t('settings.New_user_manual') }}</router-link>
                        </div>                                   
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <div class="table-container">
                            <table :key="notificationKey" id="notification-list" class="table table-flush">
                                <thead>
                                    <tr>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Title') }}</p></th>
                                        <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Active') }}</p></th>
                                        <th></th>                                           
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in notifications" v-bind:key="item.id">
                                        <td class="text-sm font-weight-normal">
                                            {{ item.title }}
                                            <span v-if="item.associationId">
                                                <br><small><b>{{ $t('settings.Association') }}</b>: {{ item.associationName }}</small>
                                            </span>
                                        </td>
                                        <td class="text-sm font-weight-normal">
                                            <i class="material-symbols-rounded opacity-10 font-size-14" 
                                                :class="item.isActive ? 'text-success' : 'text-danger'"
                                                aria-hidden="true">
                                                {{ item.isActive ? 'thumb_up' : 'thumb_down' }}
                                            </i>
                                        </td>
                                        <td>
                                            <div class="float-end">
                                                <button :data-id="item.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                                </button>
                                                <button :data-id="item.id" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')">
                                                    <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios'
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";
import { mapGetters, mapState } from "vuex";

export default {
    name: 'Settings_page',
    components: {        
    },
    data() {
        return {
            referencetypes: [],
            dataTableInstanceReferenceTypes: null,
            referenceTypeKey:0,

            usermanualtypes: [],
            dataTableInstanceUserManualTypes: null,
            userManualTypeKey:0,

            usermanuals: [],
            dataTableInstanceUserManuals: null,
            userManualKey:0,

            references: [],
            dataTableInstanceReferences: null,
            referenceKey:0,

            breeds: [],
            dataTableInstanceBreeds: null,
            breedKey:0,

            studebookstatuses: [],
            dataTableInstanceStudebookStatuses: null,
            studebookstatusKey:0,

            studebooksections: [],
            dataTableInstanceStudebookSections: null,
            studebooksectionKey:0,

            attributes: [],
            dataTableInstanceAttributes: null,
            attributeKey:0,

            mailtemplates: [],
            dataTableInstanceMailtemplateSections: null,
            mailtemplateKey:0,

            notifications: [],
            dataTableInstanceNotificationSections: null,
            notificationKey:0,

            gets: [],            
            userLoginLog: []
        }
    },
    computed: { 
        ...mapGetters(['user']),
        ...mapState(["isRTL"]),
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);

            const promises = [];

            if (this.userRoleName === 'Admin') {
                // Admin gets everything
                promises.push(
                    this.fetchAndSetData("Breed/getall/", "breeds")
                        .then(() => {
                            this.initializeBreedTable();
                            this.attachTableClickListener("#breed-list", "Edit Breed", "Breed");
                        }),
                    this.fetchAndSetData("ReferenceType/getall/", "referencetypes")
                        .then(() => {
                            this.initializeReferenceTypeTable();
                            this.attachTableClickListener("#referencetype-list", "Edit ReferenceType", "ReferenceType");
                        }),
                    this.fetchAndSetData("UserManual/getall/", "usermanuals")
                        .then(() => {
                            this.initializeUserManualTable();
                            this.attachTableClickListener("#usermanual-list", "Edit UserManual", "UserManual");
                        }),
                    this.fetchAndSetData("UserManualType/getall/", "usermanualtypes")
                        .then(() => {
                            this.initializeUserManualTypeTable();
                            this.attachTableClickListener("#usermanualtype-list", "Edit UserManualType", "UserManualType");
                        }),                    
                    this.fetchAndSetData("Reference/getall/", "references")
                        .then(() => {
                            this.initializeReferenceTable();
                            this.attachTableClickListener("#reference-list", "Edit Reference", "Reference");
                        }),
                    this.fetchAndSetData("StudebookStatus/getall/", "studebookstatuses")
                        .then(() => {
                            this.initializeStudebookStatusesTable();
                            this.attachTableClickListener("#studebookstatus-list", "Edit StudebookStatus", "StudebookStatus");
                        }),
                    this.fetchAndSetData("StudebookSection/getall/", "studebooksections")
                        .then(() => {
                            this.initializeStudebookSectionTable();
                            this.attachTableClickListener("#studebooksection-list", "Edit StudebookSection", "StudebookSection");
                        }),
                    this.fetchAndSetData("Attribute/getall/", "attributes")
                        .then(() => {
                            this.initializeAttributeTable();
                            this.attachTableClickListener("#attribute-list", "Edit Attribute", "Attribute");                            
                        }),
                    this.fetchAndSetData("Mailtemplate/getall/", "mailtemplates")
                        .then(() => {
                            this.initializeMailTemplateSectionTable();
                            this.attachTableClickListener("#mailtemplate-list", "Edit MailTemplate", "MailTemplate");
                        }),
                    this.fetchAndSetData("Notification/getall/", "notifications")
                        .then(() => {
                            this.initializeNotificationTable();
                            this.attachTableClickListener("#notification-list", "Edit Notification", "Notification");
                        })
                );                
            } else {
                // For other roles – example: load only breeds and references
                promises.push(
                    this.fetchAndSetData(`StudebookStatus/getbyassociation/?associationId=${this.$store.state.associationAdminAssociationId}`, "studebookstatuses")
                        .then(() => {
                            this.initializeStudebookStatusesTable();
                            this.attachTableClickListener("#studebookstatus-list", "Edit StudebookStatus", "StudebookStatus");
                        }),
                    this.fetchAndSetData(`StudebookSection/getbyassociation/?associationId=${this.$store.state.associationAdminAssociationId}`, "studebooksections")
                        .then(() => {
                            this.initializeStudebookSectionTable();
                            this.attachTableClickListener("#studebooksection-list", "Edit StudebookSection", "StudebookSection");
                        }),
                    this.fetchAndSetData(`Breed/getbyassociation/?associationId=${this.$store.state.associationAdminAssociationId}`, "breeds")
                        .then(() => {
                            this.initializeBreedTable();
                            this.attachTableClickListener("#breed-list", "Edit Breed", "Breed");
                        }),
                    this.fetchAndSetData(`Notification/getbyassociation/?associationId=${this.$store.state.associationAdminAssociationId}`, "notifications")
                        .then(() => {
                            this.initializeNotificationTable();
                            this.attachTableClickListener("#notification-list", "Edit Notification", "Notification");
                        })
                );
            }

            await Promise.all(promises);
            await nextTick();
        } catch (e) {
            this.showError();
        } finally {
            this.$store.commit('setShowLoading', false);
        }       
    },
    methods: {        
        async fetchAndSetData(endpoint, property) {
            try {
                const response = await axios.get(endpoint);
                const result = response.data;
                if (result.success) {
                    this[property] = result.data;
                } else {
                    this.showError();
                }
            } catch (e) {
                this.showError();
            }
        },
        attachTableClickListener(selector, editRouteName, entityName) {
             this._tableListeners = this._tableListeners || {};

            if (this._tableListeners[selector]) {
                document.removeEventListener('click', this._tableListeners[selector]);
                delete this._tableListeners[selector];
            }

            const handler = (event) => {
                const tableNode = event.target.closest(selector);
                if (!tableNode) return;
            
                const targetElement = event.target.closest('[data-id]');
                if (!targetElement) return;

                const id = targetElement.getAttribute('data-id');
                if (!id) return;
            
                if (event.target.closest('.edit-button')) {
                    this.$router.push({ name: editRouteName, params: { id } }).catch(err => {
                        console.warn('router push failed', err);
                    });
                } else if (event.target.closest('.delete-button')) {
                    this.deleteModal(id, entityName);
                }
            };

            document.addEventListener('click', handler);
            this._tableListeners[selector] = handler;
        },        
        showError() {
            this.$showError('errors.Contact_system_admin');
        },
        showDeletedSuccessfully() {
            this.$showSuccess('errors.Success_record_is_deleted_successfully');            
        },
        initializeReferenceTypeTable() {
            this.dataTableInstanceReferenceTypes = new DataTable("#referencetype-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            });
        },
        initializeUserManualTypeTable() {
            this.dataTableInstanceUserManualTypes = new DataTable("#usermanualtype-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            });
        },
        initializeUserManualTable() {
            this.dataTableInstanceUserManuals = new DataTable("#usermanual-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            });
        },
        initializeReferenceTable() {
            this.dataTableInstanceReferences = new DataTable("#reference-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            }); 
        },
        initializeBreedTable() {
            this.dataTableInstanceBreeds = new DataTable("#breed-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },                    
                    { select: 2, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),  // Translate "Search..."
                    perPage: this.$t('datatable.PerPage'),  // Translate "{select} entries per page"
                    noRows: this.$t('datatable.NoRows'),  // Translate "No entries to show"
                    info: "Tonen {start} t/m {end} van {rows} items",  // Translate "Showing {start} to {end} of {rows} entries"
                    placeholder: this.$t('common.Search') 
                }
            });
        },
        initializeStudebookStatusesTable() {
            this.dataTableInstanceStudebookStatuses = new DataTable("#studebookstatus-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },                    
                    { select: 1, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            });
        },
        initializeStudebookSectionTable() {
            this.dataTableInstanceStudebookSections = new DataTable("#studebooksection-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: false },                    
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search') 
                }
            });
        },
        initializeAttributeTable() {
            this.dataTableInstanceAttributes = new DataTable("#attribute-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),  // Translate "Search..."
                    perPage: this.$t('datatable.PerPage'),  // Translate "{select} entries per page"
                    noRows: this.$t('datatable.NoRows'),  // Translate "No entries to show"
                    info: "Tonen {start} t/m {end} van {rows} items",  // Translate "Showing {start} to {end} of {rows} entries"
                    placeholder: this.$t('common.Search') 
                }
            });
        }, 
        initializeMailTemplateSectionTable() {
            this.dataTableInstanceBreeds = new DataTable("#mailtemplate-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },                    
                    { select: 2, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),  // Translate "Search..."
                    perPage: this.$t('datatable.PerPage'),  // Translate "{select} entries per page"
                    noRows: this.$t('datatable.NoRows'),  // Translate "No entries to show"
                    info: "Tonen {start} t/m {end} van {rows} items",  // Translate "Showing {start} to {end} of {rows} entries"
                    placeholder: this.$t('common.Search') 
                }
            });
        },
        initializeNotificationTable() {
            this.dataTableInstanceNotificationSections = new DataTable("#notification-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                //perPage: 1, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },                    
                    { select: 2, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),  // Translate "Search..."
                    perPage: this.$t('datatable.PerPage'),  // Translate "{select} entries per page"
                    noRows: this.$t('datatable.NoRows'),  // Translate "No entries to show"
                    info: "Tonen {start} t/m {end} van {rows} items",  // Translate "Showing {start} to {end} of {rows} entries"
                    placeholder: this.$t('common.Search') 
                }
            });
        }, 
        async deleteModal(id, tableName) {
            this.$swal
                .fire({
                text: this.$t('common.Are_you_sure_to_delete_this_record'),
                cancelButtonText: this.$t('common.Cancel'),
                confirmButtonText: this.$t('common.Confirm_Delete'),
                showCancelButton: true,
                position: 'top-end'
                })
                .then(async (result) => {
                if (!result.isConfirmed) return;

                try {
                    this.$store.commit('setShowLoading', true);

                    const handleDeleteAndReload = async ({
                        deleteUrl,
                        getAllUrl,
                        arrayProp,
                        dataTableInstanceProp,
                        initializeFn,
                        tableSelector,
                        editRouteName,
                        incrementKeyProp
                    }) => {
                    const delResp = await axios.delete(deleteUrl + id);
                    const delResult = delResp.data;
                    if (!delResult.success) { this.showError(); return false; }

                    const allResp = await axios.get(getAllUrl);
                    const allResult = allResp.data;
                    if (!allResult.success || !Array.isArray(allResult.data)) { this.showError(); return false; }

                    this[arrayProp] = allResult.data;
                    if (incrementKeyProp) this[incrementKeyProp]++;

                    if (this[dataTableInstanceProp]) {
                        try { this[dataTableInstanceProp].destroy(); } catch (err) { console.warn('destroy datatable failed', err); }
                        this[dataTableInstanceProp] = null;
                    }

                    await nextTick();

                    if (typeof initializeFn === 'function') {
                        initializeFn.call(this);
                    }

                    // REATTACH: use tableName (the local variable) as the entity-type
                    if (tableSelector && editRouteName) {
                        this.attachTableClickListener(tableSelector, editRouteName, tableName);
                    }
                    return true;
                    };

                    // route through the different entities (same as before)
                    if (tableName === 'Breed') {
                    const ok = await handleDeleteAndReload({
                        deleteUrl: "Breed/",
                        getAllUrl: "Breed/getall",
                        arrayProp: "breeds",
                        dataTableInstanceProp: "dataTableInstanceBreeds",
                        initializeFn: this.initializeBreedTable,
                        tableSelector: "#breed-list",
                        editRouteName: "Edit Breed",
                        incrementKeyProp: "breedKey"
                    });
                    if (ok) this.showDeletedSuccessfully();

                    } else if (tableName === 'ReferenceType') {
                    const ok = await handleDeleteAndReload({
                        deleteUrl: "ReferenceType/",
                        getAllUrl: "ReferenceType/getall",
                        arrayProp: "referencetypes",
                        dataTableInstanceProp: "dataTableInstanceReferenceTypes",
                        initializeFn: this.initializeReferenceTypeTable,
                        tableSelector: "#referencetype-list",
                        editRouteName: "Edit ReferenceType",
                        incrementKeyProp: "referenceTypeKey"
                    });
                    if (ok) this.showDeletedSuccessfully();

                    } else if (tableName === 'UserManual') {
                    const ok = await handleDeleteAndReload({
                        deleteUrl: "UserManual/",
                        getAllUrl: "UserManual/getall",
                        arrayProp: "usermanuals",
                        dataTableInstanceProp: "dataTableInstanceUserManuals",
                        initializeFn: this.initializeUserManualTable, // corrected initializer
                        tableSelector: "#usermanual-list",
                        editRouteName: "Edit UserManual",
                        incrementKeyProp: "userManualKey"
                    });
                    if (ok) this.showDeletedSuccessfully();

                    } else if (tableName === 'UserManualType') {
                    const ok = await handleDeleteAndReload({
                        deleteUrl: "UserManualType/",
                        getAllUrl: "UserManualType/getall",
                        arrayProp: "usermanualtypes",
                        dataTableInstanceProp: "dataTableInstanceUserManualTypes",
                        initializeFn: this.initializeUserManualTypeTable, // corrected initializer
                        tableSelector: "#usermanualtype-list",
                        editRouteName: "Edit UserManualType",
                        incrementKeyProp: "userManualTypeKey"
                    });
                    if (ok) this.showDeletedSuccessfully();

                    } else if (tableName === 'Reference') {
                    const ok = await handleDeleteAndReload({
                        deleteUrl: "Reference/",
                        getAllUrl: "Reference/getall",
                        arrayProp: "references",
                        dataTableInstanceProp: "dataTableInstanceReferences",
                        initializeFn: this.initializeReferenceTable,
                        tableSelector: "#reference-list",
                        editRouteName: "Edit Reference",
                        incrementKeyProp: "referenceKey"
                    });
                    if (ok) this.showDeletedSuccessfully();

                    } else if (tableName === 'StudebookStatus') {
                    const ok = await handleDeleteAndReload({
                        deleteUrl: "StudebookStatus/",
                        getAllUrl: "StudebookStatus/getall",
                        arrayProp: "studebookstatuses",
                        dataTableInstanceProp: "dataTableInstanceStudebookStatuses",
                        initializeFn: this.initializeStudebookStatusesTable,
                        tableSelector: "#studebookstatus-list",
                        editRouteName: "Edit StudebookStatus",
                        incrementKeyProp: "studebookstatusKey"
                    });
                    if (ok) this.showDeletedSuccessfully();

                    } else if (tableName === 'StudebookSection') {
                    const ok = await handleDeleteAndReload({
                        deleteUrl: "StudebookSection/",
                        getAllUrl: "StudebookSection/getall",
                        arrayProp: "studebooksections",
                        dataTableInstanceProp: "dataTableInstanceStudebookSections",
                        initializeFn: this.initializeStudebookSectionTable,
                        tableSelector: "#studebooksection-list",
                        editRouteName: "Edit StudebookSection",
                        incrementKeyProp: "studebooksectionKey"
                    });
                    if (ok) this.showDeletedSuccessfully();

                    } else if (tableName === 'Attribute') {
                    const ok = await handleDeleteAndReload({
                        deleteUrl: "Attribute/",
                        getAllUrl: "Attribute/getall",
                        arrayProp: "attributes",
                        dataTableInstanceProp: "dataTableInstanceAttributes",
                        initializeFn: this.initializeAttributeTable,
                        tableSelector: "#attribute-list",
                        editRouteName: "Edit Attribute",
                        incrementKeyProp: "attributeKey"
                    });
                    if (ok) this.showDeletedSuccessfully();

                    }  else if (tableName === 'Notification') {

                    const role = this.$store.state.roleName;
                    const assocId = this.$store.state.associationAdminAssociationId;

                    const getAllUrl = role === 'Admin'
                    ? 'Notification/getall'
                    : `Notification/getbyassociation/?associationId=${encodeURIComponent(assocId ?? '')}`;

                    const ok = await handleDeleteAndReload({
                        deleteUrl: "Notification/",
                        getAllUrl,
                        arrayProp: "notifications",
                        dataTableInstanceProp: "dataTableInstanceNotificationSections",
                        initializeFn: this.initializeNotificationTable,
                        tableSelector: "#notification-list",
                        editRouteName: "Edit Notification",
                        incrementKeyProp: "notificationKey"
                    });
                    if (ok) this.showDeletedSuccessfully();
                    }

                } catch (e) {
                    console.error(e);
                    this.showError();
                } finally {
                    this.$store.commit('setShowLoading', false);
                }
            });
        },                    
    }
}
</script>

<style scoped>
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
        margin-left: -10px !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-container .table thead tr th {
        padding: 0.75rem 0.75rem !important;
    }
    ::v-deep .dataTable-wrapper .dataTable-container .table tbody tr td {
        padding: 0.5rem 0.75rem !important;
    }
    ::v-deep .dataTable-wrapper .dataTable-bottom {
        padding: 0.75rem !important;
        padding-top: 0.5rem !important;
        padding-top: 0;
    }
</style>